export const openInNewWindow = (url) => {
    window.open(url, '_blank').focus();
}